module.exports = __webpack_public_path__ + "static/media/5534b366939f2xiugai.cb20b495.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/5534b366939f2xiugai.png
// module id = 2227
// module chunks = 228